import styled from 'styled-components';

export const ReportContainer = styled.div`
  display: flex;
  background: #ededed;
  width: 100%;
`;
